var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconClock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 49.536,
    height: 50,
    viewBox: "0 0 49.536 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_223",
    "data-name": "Group 223",
    transform: "translate(-174.282 -105.706)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_76",
    "data-name": "Ellipse 76",
    cx: 19.822,
    cy: 19.785,
    rx: 19.822,
    ry: 19.785,
    transform: "translate(179.236 114.308)",
    fill: "#f3f3f1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1137",
    "data-name": "Path 1137",
    d: "M34.311,29.952H19.078a1.829,1.829,0,0,1-1.828-1.828V13.5h3.656V26.3H34.311Z",
    transform: "translate(177.06 109.779)",
    fill: "#f6781b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1139",
    "data-name": "Path 1139",
    d: "M29.149,52.225A21.613,21.613,0,1,1,50.8,30.613,21.655,21.655,0,0,1,29.149,52.225Zm0-40.138A18.525,18.525,0,1,0,47.706,30.613,18.562,18.562,0,0,0,29.149,12.088Z",
    transform: "translate(169.908 103.48)",
    fill: "#0060a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1141",
    "data-name": "Path 1141",
    d: "M0,0H8.928V3.656H0Z",
    transform: "translate(178.368 152.788) rotate(-53.336)",
    fill: "#0060a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1142",
    "data-name": "Path 1142",
    d: "M0,0H3.656V8.928H0Z",
    transform: "translate(211.451 147.824) rotate(-36.664)",
    fill: "#0060a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1143",
    "data-name": "Path 1143",
    d: "M0,0H17.234V3.656H0Z",
    transform: "translate(174.282 117.89) rotate(-45)",
    fill: "#0060a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1144",
    "data-name": "Path 1144",
    d: "M0,0H3.656V17.234H0Z",
    transform: "translate(209.048 108.294) rotate(-45)",
    fill: "#0060a6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClock);
export default __webpack_public_path__ + "static/media/icon_clock.9e274e41a022106362856fb2b328b836.svg";
export { ForwardRef as ReactComponent };